import { Box, Dialog, DialogProps, Divider, IconButton, Stack, Typography } from '@mui/material';
import { XClose } from 'untitledui-js-base';

export const BasicDialog = ({ open, onClose, title, children, ...props }: DialogProps) => {
  return (
    <Dialog open={open} {...props}>
      <Box>
        <Stack width={1} justifyContent="space-between" flexDirection="row">
          <Box p={1}>{title && <Typography variant="h6">{title}</Typography>}</Box>
          <IconButton sx={{ width: '3rem', height: '3rem' }} onClick={(event) => onClose?.(event, 'escapeKeyDown')}>
            <XClose />
          </IconButton>
        </Stack>
        <Divider />
        <Box sx={{ marginTop: '1rem', px: 2, pb: 4 }}>{children}</Box>
      </Box>
    </Dialog>
  );
};
